import React from 'react'
import PropTypes from 'prop-types'

import { Form, Icon } from 'semantic-ui-react'

const FormInputDropdownAddition = props => {
  const { error, name, onAddItem, onChange, options, pending, reset, resetVisible, text, value } = props

  const resetIcon = (
    <span>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
      <a onClick={reset}>
        <Icon color="black" name="x" />
      </a>
      <br />
    </span>
  )

  return (
    <Form.Field>
      <label>
        {text}&nbsp;
        {resetVisible && resetIcon}
      </label>

      <Form.Dropdown
        error={error}
        loading={pending}
        name={name}
        onAddItem={onAddItem}
        onChange={onChange}
        options={options}
        placeholder={text}
        value={value}
        allowAdditions
        fluid
        search
        selection
      />
    </Form.Field>
  )
}

FormInputDropdownAddition.propTypes = {
  error: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onAddItem: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  pending: PropTypes.bool.isRequired,
  reset: PropTypes.func.isRequired,
  resetVisible: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default FormInputDropdownAddition
